import { render } from "./editotherdeduction.vue?vue&type=template&id=006b74eb&scoped=true"
import script from "./editotherdeduction.vue?vue&type=script&lang=js"
export * from "./editotherdeduction.vue?vue&type=script&lang=js"

import "./editotherdeduction.vue?vue&type=style&index=0&id=006b74eb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-006b74eb"]])

export default __exports__